import { render, staticRenderFns } from "./schoolStudentList.vue?vue&type=template&id=5c2c85c8&scoped=true"
import script from "./schoolStudentList.vue?vue&type=script&lang=js"
export * from "./schoolStudentList.vue?vue&type=script&lang=js"
import style0 from "./schoolStudentList.vue?vue&type=style&index=0&id=5c2c85c8&prod&lang=scss&scoped=true"
import style1 from "./schoolStudentList.vue?vue&type=style&index=1&id=5c2c85c8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c2c85c8",
  null
  
)

export default component.exports